export default "__VITE_ASSET__DbOJUwCx__"